"use strict";

import { campaignConstants } from "../_constants";

export const INITIAL_CAMPAIGN_STATE = {
    latestCampaigns: { totalCampaigns: "", campaigns: [] },
    homeCarouselCampaigns: {
        campaigns: [],
        totalCampaigns: "",
    },
    homeBestVoucherDealsToday: {
        vouchers: [],
        totalVouchers: "",
    },

    homeTrendingVouchers: {
        vouchers: [],
        totalVouchers: "",
    },

    featuredCampaignBanners: {},

    campaignDetails: {
        isJoined: false,
        campaignTokens: [],
        content: [],

        spinwinData: {
            getData: false,
            winNumber: "",
            rewards: [],
        },

        multiStep: {
            steps: [],
        },

        terms: {
            terms: [],
            imageUrl: "",
        },

        faqs: [],

        leagueTableData: {
            participantCount: "",
            ranks: [],
        },

        leagueIndividualTableData: {
            participants: [],
            salesVerificationCodeList: [],
        },

        leagueTeamTableData: {
            teams: [],
        },

        participantSales: {
            salesCount: "",
            salesTarget: "",
            sales: [],
        },

        prizeDrawDetails: { prizeList: [], salesVerificationCodeList: [] },
    },

    campaignHomeBanners: [],
    commsDetails: {},
    teamPerformance: {},
    leagueTeam: {},
    incentiveCampaigns: [],
    campaignPerformanceMetrics: null,
    castrolDetails: [],
    contentPageLike: null,
    areaManagerDealers: [],
    participantDealersList: [],
    performanceMetricsByDealer: [],
    areaManagerLeagueSummary: [],

    batteryRank: [],
    brakePadsRank: [],
    wiperBladeRank: [],
    brakeDiscsRank: [],
    areaTopPerformerRank: [],
    nationalTopPerformer: [],
    TLCRetailes: [],

    tlcCustomers: [],
    getGoldRushCampaignPerformanceSummary: {
        goldRushCampaignPerformanceWeeklyTrackerDtos: [],
    },
    getCastrolOilFilterDetails: null,
    teamPerformanceSummary:null,
    isValidToken:null,
    alpineReward:[],
    partsManagerSaleSummary:{},
    motoGpLeaguesRankSummary:[],
    spinsData:null,
    TradePartTlcCustomers:[],
    fullThrottleLeagueRankSummary:[],
    campaignGoldenTicketScratchCardData:[],
    claimScratchCardCode:{},
    allAreaManagerDealers:[],
    isChangeRole:false,
};

export function campaign(state = INITIAL_CAMPAIGN_STATE, action) {
    switch (action.type) {
        case campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE:
            return {
                ...state,
                homeBestVoucherDealsToday: {
                    ...state.homeBestVoucherDealsToday,
                    vouchers: state.homeBestVoucherDealsToday.vouchers.map(
                        (voucher) => {
                            if (action.payload.id == voucher.id) {
                                voucher.isFavourite = true;
                            }

                            return voucher;
                        },
                    ),
                },

                homeTrendingVouchers: {
                    ...state.homeTrendingVouchers,
                    vouchers: state.homeTrendingVouchers.vouchers.map(
                        (voucher) => {
                            if (action.payload.id == voucher.id) {
                                voucher.isFavourite = true;
                            }

                            return voucher;
                        },
                    ),
                },
            };

        case campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE:
            return {
                ...state,
                homeBestVoucherDealsToday: {
                    ...state.homeBestVoucherDealsToday,
                    vouchers: state.homeBestVoucherDealsToday.vouchers.map(
                        (voucher) => {
                            if (action.payload.id == voucher.id) {
                                voucher.isFavourite = false;
                            }

                            return voucher;
                        },
                    ),
                },

                homeTrendingVouchers: {
                    ...state.homeTrendingVouchers,
                    vouchers: state.homeTrendingVouchers.vouchers.map(
                        (voucher) => {
                            if (action.payload.id == voucher.id) {
                                voucher.isFavourite = false;
                            }

                            return voucher;
                        },
                    ),
                },
            };

        case campaignConstants.SPINWHEEL_TOKEN_RESET:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    campaignTokens: [
                        ...state.campaignDetails.campaignTokens.map(
                            (spinwinToken) => {
                                spinwinToken.validate = false;
                                spinwinToken.token = "";
                                return spinwinToken;
                            },
                        ),
                    ],
                },
            };

        case campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_COMPLETE:
            return {
                ...state,
                latestCampaigns: { ...action.payload.data },
            };

        case campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_COMPLETE:
            return {
                ...state,
                homeCarouselCampaigns: { ...action.payload.data },
            };

        case campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_COMPLETE:
            return {
                ...state,
                homeBestVoucherDealsToday: { ...action.payload.data },
            };

        case campaignConstants.GET_HOME_TRENDING_VOUCHER_COMPLETE:
            return {
                ...state,
                homeTrendingVouchers: { ...action.payload.data },
            };

        case campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_COMPLETE:
            return {
                ...state,
                featuredCampaignBanners: { ...action.payload.data },
            };

        case campaignConstants.GET_CAMPAIGN_DETAILS_COMPLETE:
            const objects = [];
            for (let i = 1; i <= action.payload.data.tokenCheckCount; i++) {
                let obj = {
                    id: Math.random().toString(36).substring(2, 8),
                    validate: false,
                    token: "",
                };

                objects.push(obj);
            }

            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    campaignTokens: [...objects],
                    ...action.payload.data,
                },
            };

        case campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    campaignTokens: [
                        ...state.campaignDetails.campaignTokens.map(
                            (spinwinToken) => {
                                if (action.payload.data.id == spinwinToken.id) {
                                    spinwinToken.validate =
                                        action.payload.data.validate;
                                    spinwinToken.token =
                                        action.payload.data.token;
                                    return spinwinToken;
                                } else {
                                    return spinwinToken;
                                }
                            },
                        ),
                    ],
                },
                isValidToken:true,
            };
        case campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_ERROR:
            return{
                ...state,
                isValidToken:false,
            }   

        case campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    spinwinData: {
                        ...state.campaignDetails.spinwinData,
                        getData: true,
                        winNumber: action.payload.data,
                    },
                },
            };

        case campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_COMPLETE:
            let data = { ...action.payload.data };
            const rewardPotItems = data.rewardPotItems;
            const noRewardSlots = data.noRewardSlots;
            const winingTip = data.winningTip;


            // Get the current max ID from the existing items to start incrementing
            let nextId = Math.max(...rewardPotItems.map((item) => item.id)) + 1;

            // Create "No awards" items to be added
            let noAwardsItems = [];
            for (let i = 0; i < noRewardSlots; i++) {
                noAwardsItems.push({
                    id: nextId++, // Increment the id for each new item
                    displayName: "Unlucky",
                    displayOrder: 0, // Temporary, will be adjusted later
                });
            }

            // Randomly insert the "No awards" items into the rewardPotItems array
            for (let i = 0; i < noAwardsItems.length; i++) {
                let randomIndex = Math.floor(
                    Math.random() * (rewardPotItems.length + 1),
                ); // +1 to allow insertion at the end
                rewardPotItems.splice(randomIndex, 0, noAwardsItems[i]);
            }

            // Recalculate the displayOrder sequentially
            rewardPotItems.forEach((item, index) => {
                item.displayOrder = index + 1; // Set displayOrder starting from 1
            });

            const campaignTokenObj = [];
            for (let i = 1; i <= data.requiredQualifiers; i++) {
                let obj = {
                    id: Math.random().toString(36).substring(2, 8),
                    validate: false,
                    token: "",
                };

                campaignTokenObj.push(obj);
            }

            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    campaignTokens: [...campaignTokenObj],
                    spinwinData: {
                        ...state.spinwinData,
                        requiredQualifiers: data.requiredQualifiers,
                        rewards: action.payload.data
                            ? [...data.rewardPotItems]
                            : [],
                    },
                    winingTip:winingTip,
                    winners:data.winners
                },
            };

        case campaignConstants.JOING_INCENTIVE_DATA_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    isJoined: true,
                },
            };

        case campaignConstants.CAMPAIGN_HOME_BANNERS_COMPLETE:
            return {
                ...state,
                campaignHomeBanners: [...action.payload.data],
            };

        case campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    leagueTableData: { ...action.payload.data },
                },
            };

        case campaignConstants.GET_PARTICIPANT_SALES_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    participantSales: { ...action.payload.data },
                },
            };

        case campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    prizeDrawDetails: { ...action.payload.data },
                },
            };

        case campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    leagueIndividualTableData: { ...action.payload.data },
                },
            };

        case campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_COMPLETE:
            return {
                ...state,
                campaignDetails: {
                    ...state.campaignDetails,
                    leagueTeamTableData: { ...action.payload.data },
                },
            };

        case campaignConstants.GET_COMMS_DETAILS_COMPLETE:
            return {
                ...state,
                commsDetails: {
                    ...state.commsDetails,
                    ...action.payload.data,
                },
            };
        case campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_COMPLETE:
            return {
                ...state,
                teamPerformance: {
                    ...action.payload.data,
                },
            };
        case campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_COMPLETE:
            return {
                ...state,
                leagueTeam: {
                    ...action.payload.data,
                },
            };
        case campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_COMPLETE:
            return {
                ...state,
                leagueTeam: {
                    ...action.payload.data,
                },
            };
        case campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_COMPLETE:
            return {
                ...state,
                incentiveCampaigns: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_COMPLETE:
            return {
                ...state,
                campaignPerformanceMetrics: { ...action.payload.data },
            };
        case campaignConstants.CAMPAIGN_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_CLEAR:
            return {
                ...state,
                campaignPerformanceMetrics: null,
            };
        case campaignConstants.CAMPAIGN_PARTICIPANT_ACTIVE_CAMPAIGNS_CLEAR:
            return {
                ...state,
                incentiveCampaigns: [],
            };
        case campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_COMPLETE:
            return {
                ...state,
                castrolDetails: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_COMPLETE:
            return {
                ...state,
                castrolDetails: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_COMPLETE:
            return {
                ...state,
                contentPageLike: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_COMPLETE:
            return {
                ...state,
                areaManagerDealers: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_COMPLETE:
            return {
                ...state,
                participantDealersList: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_COMPLETE:
            return {
                ...state,
                performanceMetricsByDealer: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_COMPLETE:
            return {
                ...state,
                performanceMetricsByDealer: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE:
            return {
                ...state,
                areaManagerLeagueSummary: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_COMPLETE:
            return {
                ...state,
                batteryRank: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_COMPLETE:
            return {
                ...state,
                batteryRank: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_COMPLETE:
            return {
                ...state,
                brakePadsRank: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_COMPLETE:
            return {
                ...state,
                wiperBladeRank: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_COMPLETE:
            return {
                ...state,
                brakeDiscsRank: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_COMPLETE:
            return {
                ...state,
                areaTopPerformerRank: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_COMPLETE:
            return {
                ...state,
                nationalTopPerformer: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_COMPLETE:
            return {
                ...state,
                nationalTopPerformer: action.payload.data,
            };
        case campaignConstants.GET_TLC_CUSTOMER_COMPLETE:
            return {
                ...state,
                tlcCustomers: [...action.payload.data],
            };

        case campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE:
            return {
                ...state,
                getGoldRushCampaignPerformanceSummary: {
                    ...action.payload.data,
                },
            };
        case campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_COMPLETE:
            return {
                ...state,
                getCastrolOilFilterDetails: action.payload.data,
            };

        case campaignConstants.TLC_GET_TLC_RETAILERS_COMPLETE:
            return {
                ...state,
                TLCRetailes: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_COMPLETE:
            return {
                ...state,
                teamPerformanceSummary:action.payload?.data
            }    
        case campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_COMPLETE:
            return {
                ...state,
                serviceStartLeague: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_COMPLETE:
            return {
                ...state,
                alpineReward: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_COMPLETE:
            return {
                ...state,
                partsManagerSaleSummary: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_COMPLETE:
            return {
                ...state,
                motoGpLeaguesRankSummary: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_COMPLETE:
            return {
                ...state,
                spinsData: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_COMPLETE:
            return {
                ...state,
                tlcCustomers: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_COMPLETE:
            return {
                ...state,
                fullThrottleLeagueRankSummary: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_COMPLETE:
            return {
                ...state,
                campaignGoldenTicketScratchCardData: action.payload.data,
            };
        case campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_COMPLETE:
            return {
                ...state,
                claimScratchCardCode: action.payload.data,
            };

        case campaignConstants.CAMPAIGN_CHANGE_ROLE:
            return {
                ...state,
                isChangeRole: action.payload,
            };
        case campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_COMPLETE:
            return {
                ...state,
                allAreaManagerDealers: action.payload.data,
            };

    }

    return state;
}
